<!--
 * @FilePath: \uni-vite-vue3-project-basis-template\src\App.vue
 * @Date: 2022-10-01 21:03:09
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-11-19 13:26:28
 * @Description: 
-->

<script setup>
onLaunch(async (options) => {
  console.log('App Launch')
  console.log('应用启动路径：', options.path)
  const { appMethods } = useAppBridge()
  const systemInfo = await appMethods.getSystemInfo()
  console.log('获取到的系统信息:', '🔍 ~ onLaunch() ~ apps/YS/src/App.vue:17 ~ systemInfo:', systemInfo)
  if (systemInfo) {
    const envConfig = useEnvConfig(systemInfo)
    // console.log('🚀 ~ onLoad ~ envConfig:', envConfig)
    if (envConfig) {
      document.documentElement.setAttribute('theme-mode', 'YiS')
    }
  }
})
onShow(() => {
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
// 全局样式

/*每个页面公共css */
/* uni.css - 通用组件、模板样式库，可以当作一套ui库应用 */
/* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
@import 'uview-plus/index.scss';
/*@import '@/static/scss/theme.scss';*/
@import '@/static/scss/common.scss';
/*@import '@/static/scss/resetUview.scss';*/

/*每个页面公共css */
//@import '@/components/global/g-active-form/active-form.scss'; //注入active-form样式

.uno-start {
  --un: 0;
}

/* unocss 代码生成在这 */
.uno-end {
  --un: 0;
}

body,
html {
  overscroll-behavior: none;
  @include theme_primary(); /* 采用函数调用 */
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

uni-page-body {
  min-height: 100%;
  color: #0a0a0a;
  font-family: PingFangSC-Semibold, PingFang SC;
  box-sizing: border-box;
}
.uni-tabbar-bottom {
  // z-index: 9;
}

/* .container {
   height: 100%;
   width: auto;
   flex-direction: column;
 }
 .icon {
   width: 1em;
   height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
 } */
/* #ifdef H5 */
uni-page-head {
  display: none;
}
#__vconsole {
  position: fixed;
  z-index: 99999999999999;
}
/* #endif */
</style>
